export const updateWishlist = (activities, activity, isWishlist) => {
    const activityIndex = activities.findIndex(item => activity.id === item.info.id)
    activities[activityIndex].wishlist = isWishlist
}

export const updateActivityWishlist = (activities, activity, isWishlist) => {
    const activityIndex = activities.findIndex(item => activity.id === item.id)

    if (activityIndex >= 0) {
        if (!isWishlist) {
            activities.splice(activityIndex, 1)
        } else activities[activityIndex].wishlist = isWishlist
    } else if (isWishlist) {
        activity.wishlist = isWishlist
        activities.push(activity)
    }
}
